import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { AddressByAssessmentNumberModel } from "@/api/AddressLookup";

export type GetAddressByAssessementNumberRequest = {
  assessmentNumber: string;
};

export type GetAddressByAssessementNumberResponse = {
  addressInfo: AddressByAssessmentNumberModel | undefined;
};

export const getAddressByAssessmentNumber = async (request: GetAddressByAssessementNumberRequest): Promise<GetAddressByAssessementNumberResponse> => {
  const url = "/addresssuggestions/getbyassessmentnumber";
  const response = await executeApiRequest(
    () => axios.get<GetAddressByAssessementNumberResponse>(url, { params: request }),
    false
  );
  return response?.data;
};
